import { useContext } from 'react';
import WishListContext from 'contexts/WishList/WishListContext';

export default function useWishList(productId) {
    const { actions, state } = useContext(WishListContext);
    const productIds = state.productIds;
    const showIconWishlist = state.areProductIdsLoaded;

    const isInWishList =
        !!productIds && productIds.some(id => id === parseInt(productId, 10));

    return [{ isInWishList, showIconWishlist }, actions];
}
